export default __webpack_public_path__ + "media/images/backgrounds/mud-splats-b37199c47cbcca500525be543be30745.svg";